import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
export const InlineActionButtons = styled(Grid)(({ theme })=>({
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            margin: theme.spacing(2, 0, 1)
        }
    }));
InlineActionButtons.defaultProps = {
    size: {
        xs: 12,
        md: 'auto'
    }
};
export const FullSizeActionButtons = styled(Box)(({ theme })=>({
        display: 'flex',
        flexDirection: 'row',
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            alignItems: 'flex-start'
        }
    }));
